/**
 * App Config File
 */
export default {
  appSgLogo: '//public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/logo.svg', // App Logo,
  darkSGLogo: '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/img_bi_black_sg.png', // dark logo
  appCgLogo: '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/cloudgate_bi_horizontal.svg', // App Logo,
  darkCgLogo: '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/cloudgate_bi_horizontal_white.svg"', // dark logo
  brand: 'Vuely', // Brand Name
  copyrightText: 'Vuely © 2018 All Rights Reserved.', // Copyright Text
  enableUserTour: process.env.NODE_ENV === 'production', // Enable User Tour,
  appSgOgImg: 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/img/img_og_image_sg.png',
  appCgOgImg: 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/img/img_og_image_cg.png'
}



// WEBPACK FOOTER //
// ./src/constants/AppInfo.js